export default "__VITE_ASSET__CIisUTKo__"